import { createSlice } from "@reduxjs/toolkit";
import {
  getResponsePhraseByIdThunk,
  getResponsePhrasesByPlantelThunk,
  updateResponsePhraseThunk,
} from "./plantels.thunks";

const initialState = {
  list: [],
  loading: false,
  error: null,

  page: 1,
  pageSize: 10,
  count: 0,

  // VIEW
  selectedPhrase: null,
  selectedPhraseLoading: false,
  selectedPhraseError: null,
  viewModalOpen: false,

  editModalOpen: false,
  editLoading: false,
  editError: null,
};

const responsePhrasesSlice = createSlice({
  name: "responsePhrases",
  initialState,
  reducers: {
    setResponsePhrasesPage: (state, action) => {
      state.page = action.payload;
    },

    openResponsePhraseView: (state) => {
      state.viewModalOpen = true;
    },

    closeResponsePhraseView: (state) => {
      state.viewModalOpen = false;
      state.selectedPhrase = null;
    },

    openResponsePhraseEdit: (state, action) => {
      state.editModalOpen = true;
      state.selectedPhrase = action.payload;
    },

    closeResponsePhraseEdit: (state) => {
      state.editModalOpen = false;
      state.editError = null;
    },
  },

  extraReducers: (builder) => {
    builder
      .addCase(getResponsePhrasesByPlantelThunk.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(getResponsePhrasesByPlantelThunk.fulfilled, (state, action) => {
        state.loading = false;

        const payload = action.payload;
        state.list = payload.results || payload || [];
        state.count = payload.count || state.list.length;
      })
      .addCase(getResponsePhrasesByPlantelThunk.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })

      // GET BY ID
      .addCase(getResponsePhraseByIdThunk.pending, (state) => {
        state.selectedPhraseLoading = true;
      })
      .addCase(getResponsePhraseByIdThunk.fulfilled, (state, action) => {
        state.selectedPhraseLoading = false;
        state.selectedPhrase = action.payload;
      })
      .addCase(getResponsePhraseByIdThunk.rejected, (state, action) => {
        state.selectedPhraseLoading = false;
        state.selectedPhraseError = action.payload;
      })
      // TOGGLE
      .addCase(updateResponsePhraseThunk.pending, (state) => {
        state.editLoading = true;
        state.editError = null;
      })
      .addCase(updateResponsePhraseThunk.fulfilled, (state, action) => {
        state.editLoading = false;

        const updated = action.payload;

        const idx = state.list.findIndex((p) => p.id === updated.id);
        if (idx !== -1) state.list[idx] = updated;

        state.selectedPhrase = updated;
        state.editModalOpen = false;
      })
      .addCase(updateResponsePhraseThunk.rejected, (state, action) => {
        state.editLoading = false;
        state.editError = action.payload;
      });
  },
});

export const {
  setResponsePhrasesPage,
  openResponsePhraseView,
  closeResponsePhraseView,
  openResponsePhraseEdit,
  closeResponsePhraseEdit,
} = responsePhrasesSlice.actions;

export default responsePhrasesSlice.reducer;
